import { useSettingDiscoverPageImprovements } from "@faire/retailer-visitor-shared/settings/useSettingDiscoverPageImprovements";
import { useSearchPageFilters } from "@faire/retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageFilters";
import { useSearchPageParsedSearch } from "@faire/retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageParsedSearch";
import { useSearchPageZeroIndexedPageNumber } from "@faire/retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageZeroIndexedPageNumber";
import { useQuery_escape_hatch as useDiscoverPageFilteredSectionsQuery } from "@faire/web-api--source/endpoints/www/api/seo/filtered-sections/post-hooks";
import { IDiscoverPageFilteredSectionsRequest } from "@faire/web-api--source/indigofair/data/IDiscoverPageFilteredSectionsRequest";
import { keepPreviousData } from "@tanstack/react-query";

export const useDiscoverPageFilteredProductGrids = () => {
  const isDiscoverPageImprovements = useSettingDiscoverPageImprovements();
  const query = useSearchPageParsedSearch().q;
  const filters = useSearchPageFilters();
  const page = useSearchPageZeroIndexedPageNumber();
  const request = IDiscoverPageFilteredSectionsRequest.build({
    query,
    filters: filters.join(","),
  });
  const { data } = useDiscoverPageFilteredSectionsQuery(request, {
    enabled: !!query && isDiscoverPageImprovements,
    staleTime: Infinity,
    placeholderData: keepPreviousData,
  });

  if (page !== 0 || filters.length > 0) {
    return {
      filteredProductGrids: [],
      requestId: "",
    };
  }

  return {
    filteredProductGrids: data?.filtered_product_grids ?? [],
    requestId: data?.request_id ?? "",
  };
};
